import React, { useEffect, useState } from "react";
import Header from "../../Components/HeaderAdmin/Header";
import { Form } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { useLocation, useParams } from 'react-router-dom';
import { updateStaff, getStaffById } from "../../Api/staff";
import { getErrorByField, getUserById } from "../../Api/auth";
function StaffView() {
    const params = useParams();
    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);

    const initData = {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        password: "",
        facebook_id: "",
        twitter_id: "",
        instagram_id: "",
        role_id: "",
        confirmPassword: ""
    };
    const [formData, setFormData] = useState(initData);
    const dataChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (params.id !== undefined && params.id !== null) {
            getDataById();
        }
    }, [])


    const getDataById = async (event) => {
        getStaffById({ _id: params.id }, event).then((res) => {
            console.log("res", res);
            if (res?.code === 200) {
                setFormData(res.data.data);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        formData._id = params.id;
        updateStaff(formData, e).then((res) => {
            console.log(res);
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(res.data.message);
            } else {
                getDataById()
                setApicall(false);
                handleShow();
                window.location.href = "/staff";
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    }
    const [pageStage, setPageStage] = useState("view");
    const handleEditView = () => {
        pageStage === "view" ? setPageStage("edit") : setPageStage("view");
    }
    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="logo-modal mb-4 text-center">
                        <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                    </div>
                    <h3 className="text-center">
                        staff add successfully
                    </h3>
                </Modal.Body>
            </Modal>
            <div className="main-page-body-content-header">
                <Header />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="sec-header-dash">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>Staff Profile</h3>
                                        </div>
                                        <div className="content-box-btn">
                                            <button className="btn btn-add" onClick={handleEditView}>{pageStage === "view" ? "Edit" : "View"}</button>
                                        </div>
                                    </div>
                                    <div className="dashboard-sec">
                                        <div className="container-fulid">
                                            <Form noValidate validated={validated} onSubmit={handleUpdateSubmit}>
                                                <fieldset disabled={pageStage === "view" ? true : false}>
                                                    <div className="form-box-section mt-4">
                                                        <div className="form-box-inner">
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-6">
                                                                        <label className="dashboard-form-lable">Name</label>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="First"
                                                                        required
                                                                        className={`form-control dashboard-input-box-1 me-1  ${errors.length > 0 ? getErrorByField(errors, "firstname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        value={formData.firstname}
                                                                        name={"firstname"}
                                                                        onChange={(e) => dataChange(e)} />
                                                                    <input
                                                                        type="text"
                                                                        required
                                                                        className={`form-control dashboard-input-box-1 me-1  ${errors.length > 0 ? getErrorByField(errors, "lastname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        placeholder="Last"
                                                                        value={formData.lastname}
                                                                        name={"lastname"}
                                                                        onChange={(e) => dataChange(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-4">
                                                                        <label className="dashboard-form-lable">Email</label>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input
                                                                            type="email"
                                                                            required
                                                                            className={`form-control dashboard-input-box-2  ${errors.length > 0 ? getErrorByField(errors, "email").length > 0 ? "is-invalid" : "" : ""}`}
                                                                            placeholder="Email Address"
                                                                            value={formData.email}
                                                                            name={"email"}
                                                                            onChange={(e) => dataChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-4">
                                                                        <label className="dashboard-form-lable">Phone</label>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input
                                                                            type="number"
                                                                            placeholder="Phone Number"
                                                                            required
                                                                            className={`form-control dashboard-input-box ${errors.length > 0 ? getErrorByField(errors, "phone").length > 0 ? "is-invalid" : "" : ""}`}
                                                                            value={formData.phone}
                                                                            name={"phone"}
                                                                            onChange={(e) => dataChange(e)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-item" style={{ display: "none" }}>
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-4">
                                                                        <label className="dashboard-form-lable">Password</label>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input
                                                                            type="password"
                                                                            placeholder="Password"
                                                                            required
                                                                            className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "password").length > 0 ? "is-invalid" : "" : ""}`}
                                                                            value={formData.password}
                                                                            name={"password"}
                                                                            onChange={(e) => dataChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-item" style={{ display: "none" }}>
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-4">
                                                                        <label className="dashboard-form-lable">Confirm Password</label>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input
                                                                            type="password"
                                                                            required
                                                                            className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "confirmPassword").length > 0 ? "is-invalid" : "" : ""}`}
                                                                            value={formData.confirmPassword}
                                                                            name={"confirmPassword"}
                                                                            onChange={(e) => dataChange(e)} placeholder="Confirm Password" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-4">
                                                                        <label className="dashboard-form-lable">Role</label>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <select
                                                                            required
                                                                            className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "role_id").length > 0 ? "is-invalid" : "" : ""}`}
                                                                            value={formData.role_id}
                                                                            name={"role_id"}
                                                                            onChange={(e) => dataChange(e)}>
                                                                            <option defaultChecked>Select Role</option>
                                                                            <option value={"2"}>Admin</option>
                                                                            <option value={"1"}>Fitter</option>
                                                                            <option value={"5"}>Staff</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-4">
                                                                        <label className="dashboard-form-lable" >Facebook Link</label>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input type="text"
                                                                            className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "facebook_id").length > 0 ? "is-invalid" : "" : ""}`}
                                                                            required
                                                                            placeholder="Facebook Link"
                                                                            value={formData.facebook_id}
                                                                            name={"facebook_id"}
                                                                            onChange={(e) => dataChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-4">
                                                                        <label className="dashboard-form-lable">Instagram Link</label>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input type="text" className={`form-control dashboard-input-box  ${errors.length > 0 ? getErrorByField(errors, "instagram_id").length > 0 ? "is-invalid" : "" : ""}`}
                                                                            required
                                                                            placeholder="Instagram Link"
                                                                            value={formData.instagram_id}
                                                                            name={"instagram_id"}
                                                                            onChange={(e) => dataChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-4">
                                                                        <label className="dashboard-form-lable">Twitter Link</label>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control dashboard-input-box"
                                                                            placeholder="Twitter Link"
                                                                            value={formData.twitter_id}
                                                                            name={"twitter_id"}
                                                                            onChange={(e) => dataChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                    {pageStage === "view" ? "" : (
                                                        <div className="sec-btn-group add_customer_btn mt-4">
                                                            <Link to="/staff">
                                                                <button className="btn btn-cancel">Exit without saving</button>
                                                            </Link>
                                                            {apicall ? (
                                                                <button className="btn btn-save"><Spinner animation="border" className="border-black" /> </button>
                                                            ) : (
                                                                <button className="btn btn-save" type="submit">Update Staff</button>)}
                                                        </div>
                                                    )}
                                                </fieldset>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StaffView;